import React, { useEffect, useState } from 'react';
import './Contact.scss';
import ContactHeader from './ContactHeader';
import Footer from '../Footer/Footer';
import { Formik , Field , Form } from 'formik';
import { ContactValidaion } from '../Validation/Validation';
import contactServices from '../../Services/contact.services'

const Contact = () =>  {

  const imaBlankBlks = [
    {
      role: 'Front-End Developer',
      type: 'fron-end',
      enum: 'FrontEnd'
    },
    {
      role: 'Back-End Developer',
      type: 'back-end',
      enum: 'BackEnd'
    },
    {
      role: 'Full Stack Developer',
      type: 'full-end',
      enum: 'FullStack'
    },
    {
      role: 'Web Designer',
      type: 'web-des',
      enum: 'WebDesigner'
    },
    {
      role: 'App Developer',
      type: 'app-dev',
      enum: 'AppDeveloper'
    },
    {
      role: 'App Designer',
      type: 'app-des',
      enum: 'AppDesigner'
    },
  ]


  const [messageValue , setMessageValue] = useState('');
  const [roleSetter , setRoleSetter] = useState('');
  const [cError , setCError] = useState(false)

  const contactValues = {
    userName: '',
    email: '',
    phoneNumber: ''
  }

  const contactFormSubmit = (data) => {
    console.log(data)
  }

  const handleClick = (type) => {
    if (roleSetter === type) {
      // If the button is already active, deactivate it
      setRoleSetter('');
    } else {
      // Otherwise, activate the button
      setRoleSetter(type);
    }
  };

  console.log(roleSetter , "contacter")

  const numbersOnlyInput = (e) => {
    var key = e.key;
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      e.preventDefault();
    }
    else {
      console.log("You pressed a key: " + key);
    }
  }


  // Create Funtion
  const createContact = async(data) => {
    const obj = {
      userName: data.userName,
      email: data.email,
      mobileNumber: data.phoneNumber,
      message: messageValue,
      role: roleSetter
    }
    try {
      const response = await contactServices.contactSgCodes(obj)
      if(response) {
        console.log(response);
        setCError(false)
      }
    } catch (error) { 
      setCError(true)
      console.log(error)
    }
  }

  useEffect(() => {
    document.title = 'SGCodes - Contact';
  }, [])


  return (
    <div className="Contact">
      <ContactHeader/>
        <div className="contact-main-section">
          <section>
            <div className="contact-section-1 py-16">
              <div className="contact-section-1-inner container">
                <div className="grid-cols-2 grid gap-8 shadow-cardsShadow rounded-[30px] pl-8 pr-10 py-8">
                  <div className="contact-main-left">
                    <div className="w-full h-full inner-contact-main-left">
                      <div className=" contact-section-left top-image-view bg-purple  bg-opacity-20 h-full rounded-2xl flex flex-col gap-10 overflow-hidden">
                        <div className="bottom-contact-image-sec">
                          <img src={require('../../images/aboutme-images/contact-right.jpg')} className='w-full h-full object-cover rounded-t-2xl max-h-[480px]' alt="" />
                        </div>
                        <div className="top-contact-page-address-sec px-6 pb-6">
                          <div className="top-three-blocks-addresses flex flex-col gap-8">
                            <div className="email-add-section flex items-center gap-4 group">
                              <div className="email-ico-blk bg-white  rounded-full w-16 h-16 flex group-hover:bg-homeblack duration-500 items-center justify-center">
                                <i className="bi bi-envelope-at text-homeblack group-hover:text-white duration-500 text-2xl"></i>
                              </div>
                              <div className="email-para-blk">
                                <h4 className='font-Manrope '>Email</h4>
                                <a href='mailto:sg83362@gmail.com' className='font-DmSans text-homeblack text-2xl'>sg83362@gmail.com</a>
                              </div>
                            </div>
                            <div className="email-add-section flex items-center gap-4 group">
                              <div className="email-ico-blk bg-white  rounded-full w-16 h-16 flex group-hover:bg-homeblack duration-500 items-center justify-center">
                                <i className="bi bi-telephone text-homeblack group-hover:text-white duration-500 text-2xl"></i>
                              </div>
                              <div className="email-para-blk">
                                <h4 className='font-Manrope '>Phone</h4>
                                <a href='tel:9245687852' className='font-DmSans text-homeblack text-2xl'>+91 9014579785</a>
                              </div>
                            </div>
                            <div className="email-add-section flex items-center gap-4 group">
                              <div className="email-ico-blk bg-white  rounded-full w-16 h-16 flex group-hover:bg-homeblack duration-500 items-center justify-center">
                                <i className="bi bi-buildings text-homeblack group-hover:text-white duration-500 text-2xl"></i>
                              </div>
                              <div className="email-para-blk">
                                <h4 className='font-Manrope '>Address</h4>
                                <a href='https://maps.app.goo.gl/xzNagVo4MF7CKYHu8' target='_blank' className='font-DmSans text-homeblack text-2xl'>Kakinada , Andhrapradesh - India</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                        {/* <div className="h-1/2 contact-section-left bottom-map-view">
                        <iframe className='w-full' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61055.27431433624!2d82.24723270000001!3d16.976781149999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3827ddaf59b4f7%3A0x92f8ddb9c89a4803!2sKakinada%2C%20Andhra%20Pradesh!5e0!3m2!1sen!2sin!4v1712383694826!5m2!1sen!2sin"  height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div> */}
                    </div>
                  </div>
                  <div className="contact-main-right">
                    <div className="w-full mr-auto inner-contact-main-right">
                        <div className="contact-rigt-form">
                          <div className="left-side-contact-inner">
                              <div className="above-the-form-section-contact">
                                <div className="top-get-intouch-head mt-5 mb-3">
                                  <h2 className="text-6xl font-DmSans leading-[70px] text-homeblack font-medium"><span>Let's Chat</span>, Reach Out to Me</h2>
                                </div>
                                <div className="feedback-para">
                                  <p className='text-lg font-Manrope text-homeblack'>Have questions or feedback? I'm here to help. Send me a message, and i'll respond with in 24hours</p>
                                </div>
                              </div>
                              <div className="below-form-section-contact pt-6 pb-8">
                                <Formik
                                  validationSchema={ContactValidaion}
                                  initialValues={contactValues}
                                  onSubmit={(values) => createContact(values)}
                                >
                                  {({  errors, touched }) => (
                                    <Form>
                                      <div className="top-firs-last-name flex flex-col gap-6">
                                        <div className="first-name-section">
                                          <div className="top-form-name-section grid grid-cols-2 gap-4">
                                            <div className="form-inputsec relative">
                                              <Field type="text" name="userName" placeholder='User Name' 
                                                className={`outline-none border py-3 pr-5 pl-11 rounded-xl bg-transparent font-Manrope w-full ${errors.userName && touched.userName ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500' : 'border-homeblack border-opacity-30'}`} 
                                              />
                                              <div className="absolute-icon left-side-contact absolute top-[7px] left-3">
                                                <i className={`bi bi-person opacity-80 ${errors.userName && touched.userName ? 'text-red-500' : 'text-homeblack' } text-2xl`}></i>
                                              </div>
                                            </div>
                                            {/* <div className="form-inputsec relative">
                                              <Field type="text" name="lastName" placeholder='Last Name' 
                                                className={`outline-none border py-3 pr-5 pl-11 rounded-xl bg-transparent font-Manrope w-full ${errors.lastName && touched.lastName ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500' : 'border-homeblack border-opacity-30'}`} 
                                              />
                                              <div className="absolute-icon left-side-contact absolute top-[7px] left-3">
                                                <i className={`bi bi-person opacity-80 ${errors.lastName && touched.lastName ? 'text-red-500' : 'text-homeblack' } text-2xl`}></i>
                                              </div>
                                            </div>   */}
                                            <div className="last-name-sec">
                                              <div className="form-inputsec relative">
                                                <Field type="tel" name="phoneNumber" placeholder='Phone Number' onKeyPress={(e) => numbersOnlyInput(e)} 
                                                  className={`outline-none border py-3 pr-5 pl-11 rounded-xl bg-transparent font-Manrope w-full ${errors.phoneNumber && touched.phoneNumber ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500' : 'border-homeblack border-opacity-30'}`} 
                                                />
                                                <div className="absolute-icon left-side-contact absolute top-[7px] left-3">
                                                    <i className={`bi bi-phone opacity-80 ${errors.phoneNumber && touched.phoneNumber ? 'text-red-500' : 'text-homeblack' } text-2xl`}></i>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="email-section col-span-2">
                                              <div className="form-inputsec relative">
                                                <Field type="email" name="email" placeholder='Email'
                                                  className={`outline-none border py-3 pr-5 pl-11 rounded-xl bg-transparent font-Manrope w-full ${errors.email && touched.email ? 'inputError border-red-500 border-opacity-100 bg-red-500 bg-opacity-10 placeholder:text-red-500' : 'border-homeblack border-opacity-30'}`} 
                                                />
                                                <div className="absolute-icon left-side-contact absolute top-[7px] left-3">
                                                    <i className={`bi bi-envelope-at opacity-80 ${errors.email && touched.email ? 'text-red-500' : 'text-homeblack' } text-2xl`}></i>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="ima-blank-developer-block">
                                          <div className="grid grid-cols-3 gap-3">
                                            {imaBlankBlks.map((items , index) => {
                                              return (
                                                <button className={`text-left inner-singleima-blocks p-3 rounded-xl duration-500  relative ${items.enum === roleSetter ? 'bg-greenYellow' : 'bg-homeblack bg-opacity-20'}`} onClick={() => handleClick(items.enum)} type='button' key={index}>
                                                  <div className="ima-head mb-1">
                                                    <h4 className='text-homeblack font-DmSans font-semibold text-lg'>I'm a</h4>
                                                  </div>
                                                  <div className="bottom-ima-content">
                                                    <p className='text-homeblack font-Manrope font-semibold text-sm'>{items.role}</p>
                                                  </div>
                                                  <div className={`absolute-checker absolute top-2 right-3`}>
                                                    <i className={`bi bi-check-circle-fill text-xl duration-500 ${items.type === roleSetter ? 'text-homeblack' : 'text-white'}`}></i>
                                                  </div>
                                                </button>
                                              )
                                            })}
                                          </div>
                                        </div>
                                        <div className="email-section col-span-2">
                                          <div className="form-inputsec">
                                            <textarea placeholder='Leave me a message' onKeyUp={(e) => setMessageValue(e.target.value)}
                                              className='outline-none border border-homeblack border-opacity-30 py-3 px-5 rounded-xl bg-none font-Manrope w-full resize-none h-36'>
                                            </textarea>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="bottom-form-submitter w-1/2 mt-6 rounded-xl overflow-hidden relative group">
                                          <button type='submit' className='w-full py-3 px-4 rounded-xl font-DmSans text-white bg-homeblack font-semibold hover:bg-greenYellow hover:text-black text-lg duration-500'>Submit</button>
                                      </div>
                                    </Form>
                                  )}
                                </Formik>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      <Footer/>
    </div>
  );
}

Contact.propTypes = {};

Contact.defaultProps = {};

export default Contact;
